/**
 * Coming Soon Placeholder Page
 * Used for features that are not yet implemented
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ComingSoonPage.module.css';

export const ComingSoonPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.contentBox}>
        {/* Icon */}
        <div className={styles.icon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>

        {/* Heading */}
        <h1 className={styles.heading}>Feature Coming Soon</h1>

        {/* Description */}
        <p className={styles.description}>
          We're working on bringing this feature to you. This page will be available in an upcoming release.
        </p>

        {/* Status */}
        <div className={styles.status}>
          <div className={styles.statusDot} />
          <span>Under Development</span>
        </div>

        {/* Back Button */}
        <button
          onClick={() => navigate('/dashboard')}
          className={styles.backButton}
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
};
